<template>
    <div class="container">
        <h1 class="title">{{langConfig[lang].titleOverview}}</h1>

        <div class="stats">
            <div class="game-info">
                <!-- <h4 class="item-name">Aktuální skóre - <span class="item-value">{{ round }}</span></h4> -->
                <h4 class="item-name">
                    {{langConfig[lang].actual_score}} - <span class="item-value">{{ !score ? "---" : score }}</span>
                </h4>
                <h4 class="item-name">
                    <span>
                        {{langConfig[lang].level}} - <span class="item-value">{{ level }}</span>
                    </span>

                    <div class="level-progress">
                        <div v-for="index in 5" :key="index">
                            <font-awesome-icon
                                :icon="['fas', 'check']"
                                :class="['check-icon', {'checked': isCheckChecked(index)}]"
                            />
                        </div>
                    </div>
                </h4>
                <h4 class="item-name">
                    {{langConfig[lang].time}} - <span class="item-value">{{ !formatTime ? "00:00" : formatTime }}</span>
                </h4>
            </div>
    
            <div class="high-stats">
                <h4 class="item-name">
                    <font-awesome-icon :icon="['far', 'user']" />
                    {{langConfig[lang].name}} - <span class="item-value">{{ !name ? "---" : name }}</span>
                </h4>
                <h4 class="item-name">
                    <font-awesome-icon :icon="['fas', 'medal']" />
                    {{langConfig[lang].high_score}} - <span class="item-value">{{ !highestGameScore ? "---" : highestGameScore}}</span>  
                </h4>
                <h4 class="item-name">
                    <font-awesome-icon :icon="['far', 'clock']" />
                    {{langConfig[lang].last_score}} - <span class="item-value">{{ !lastGameScore ? "---" : highestGameScore }}</span>
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
import configLang from "../assets/config.json";
    export default {
        props: ["lang", "round", "level", "lastGameScore", "highestGameScore", "formatTime", "score", "name"],
        data(){
            return {
                spendTime: 2,
                highScore: 20,
                lastScore: 13,
                langConfig: configLang,
            }
        },
        methods: {
            isCheckChecked(index){
                if(this.round%5 - 1 == 0 && this.round != 1){
                    return true;
                }else if(this.round < 10){
                    if(index <= this.round%5 - 1){
                        return true;
                    }
                }

                return false;
            },
            startLearningModule(index){
                if(this.$parent.module.modules[index].status != "success"){
                    this.$parent.module.modules[index].status = "during";
                    this.$parent.module.modules[index].isOpen = true;
                }
            }
        }
    }
</script>


<style lang="scss" scoped>
    .container {
        margin: 0;
        padding: 20px;
    }

    .title {
        font-size: 18px;
        text-align: center;
        margin-bottom: 15px;
    }

    .stats {
        display: flex;
        justify-content: center;
        gap: 10px
    }

    .high-stats, .game-info {
        display: flex;
        flex-direction: column;
        gap: 20px;

        background: white;
        border-radius: 15px;
        padding: 15px;
        width: 50%;
    }

    .item-name {
        display: flex;
        align-items: center;
        gap: 5px;

        .item-value {
            font-weight: 600;
        }

        .level-progress{
            display: flex;
            align-items: center;
            gap: 5px;
            margin-left: 10px;
            
            .check-icon{
                color: rgb(138, 138, 138);
                font-size: 25px;
            }

            .checked{
                color: green !important;    
            }
        }
    }

    @media only screen and (max-width: 800px){
        .title {
            font-size: 17px !important;
        }

        .stats{
            flex-direction: column;
        }

        .high-stats, .game-info {
            width: 100%;
        }
    }

</style>